// extracted by mini-css-extract-plugin
export var boldText = "_3q-4";
export var checkboxContainer = "_3q-6";
export var closeIcon = "_3q-g";
export var container = "_3q-0";
export var drawer = "_3q-8";
export var drawerContent = "_3q-9";
export var extraSmallText = "_3q-5";
export var fulfillmentGroupTable = "_3q-e";
export var largeText = "_3q-3";
export var loadingSpinnerContainer = "_3q-h";
export var mediumText = "_3q-2";
export var narrow = "_3q-f";
export var notificationLink = "_3q-j";
export var packageCheckIconContainer = "_3q-7";
export var slideoutHeaderContainer = "_3q-a";
export var slideoutModal = "_3q-c";
export var stickyHeaderWrapper = "_3q-b";
export var table = "_3q-i";
export var tableContainer = "_3q-d";
export var tertiaryText = "_3q-1";